import { useEffect } from 'react';
import useLatest from '../useLatest';

const useOutsideClick = (
	elementRef: any,
	handler: any,
	attached: boolean,
	modalId?: string,
	wrapperRef?: any) => {
	const latestHandler = useLatest(handler);

	useEffect(() => {
		if (!attached) return;

		const handleClick = (e: any) => {
			if (!elementRef.current) return;
			if (!elementRef.current.contains(e.target)
				&& !wrapperRef?.current.contains(e.target)
			) {
				latestHandler.current();
			}
		};

		document.addEventListener('click', handleClick);
		return () => document.removeEventListener('click', handleClick);
	}, [elementRef, latestHandler, attached, modalId]);
};

export default useOutsideClick;
